// custom scripts
// mcs / 2018

// WINDOW SCROLLED
$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }

  
});

$(document).ready(function() {


  //alert("Your location is: " + geoplugin_countryName() + ", " + geoplugin_region() + ", " + geoplugin_city());

  //console.log( "ready!" );
  $('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready3');
  }, 3000);



  // get variant data attr and repplace string
  // $('.grid-variant').each(function() {
  //   var yo2 = $(this).data('color').replace(/-/g," | ");
  //   //console.log(yo2);
  //   newstr = yo2.substring(yo2.indexOf("_") + 1);
  //   $(this).html('<span>' + newstr  + '</span>');
  // });


  // new menu
  $('.drop-menu-open').hover(function() {
    $('.roav-dropdown-menu').addClass('active');
  }, function() {
    $('.roav-dropdown-menu').removeClass('active');
  });




  // DROPDOWNS

  // $('.support-hover').hover(function() {
  //   $('.roav-dropdown-menu').removeClass('shop-active');
  //   $('.roav-dropdown-menu').removeClass('about-active');  
  //   $('.roav-dropdown-menu').addClass('support-active');
  // }, function() {
  //   //$('.roav-dropdown-menu').removeClass('support-active');
  // });
  // // about hover
  // $('.about-hover').hover(function() {
  //   $('.roav-dropdown-menu').removeClass('shop-active');
  //   $('.roav-dropdown-menu').removeClass('support-active');  
  //   $('.roav-dropdown-menu').addClass('about-active');
  // }, function() {
  //   //$('.roav-dropdown-menu').removeClass('about-active');
  // });

  // // shop hover
  // $('.shop-hover').hover(function() {
  //   $('.roav-dropdown-menu').removeClass('about-active');
  //   $('.roav-dropdown-menu').removeClass('support-active');  
  //   $('.roav-dropdown-menu').addClass('shop-active');
  // }, function() {
  //   //$('.roav-dropdown-menu').removeClass('about-active');
  // });

  // // general drop menu stay open
  // $('.roav-dropdown-menu').hover(function() {
  //   $('.roav-dropdown-menu').addClass('active');
  // }, function() {
  //   $('.roav-dropdown-menu').removeClass('active');
  // });





  // get variant name
  // var text = $('.variant-clicker.active').data('color').replace(/-/g,"<em> | </em>");
  // newstr = text.substring(text.indexOf("_") + 1);
  // $('.print-variant').html('<span>' + newstr  + '</span>');
  // // update variant nam
  // $('#ProductSelect-option-0 .variant-clicker').click(function() {
  //     var text = $(this).data('color').replace(/-/g," | ");
  //     newstr = text.substring(text.indexOf("_") + 1);
  //     $('.print-variant').html('<span>' + newstr + '</span>');

  //     $('.single-option-radio label').removeClass('active');
  //     $(this).addClass('active');

  //     alert("Hello world!");
  // });


  // clicks
  $('#shipping-toggle-open').click(function() {
    $('#shipping-pullout').addClass('active');
  });
  $('#shipping-toggle-close').click(function() {
    $('#shipping-pullout').removeClass('active');
  });


  $('.include-tooltips').click(function() {
    $(this).toggleClass('active');
  });




  // percentage off filters
  $('.all-items').click(function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('#CollectionSection').removeClass('show-new');
    $('#CollectionSection').removeClass('show-20-off');
    $('#CollectionSection').removeClass('show-50-off');
    $('#CollectionSection').removeClass('show-30-off');
    $('#CollectionSection').removeClass('show-40-off');
  });
  $('.btn-new').click(function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('#CollectionSection').addClass('show-new');
    $('#CollectionSection').removeClass('show-20-off');
    $('#CollectionSection').removeClass('show-50-off');
    $('#CollectionSection').removeClass('show-30-off');
    $('#CollectionSection').removeClass('show-40-off');
  });
  $('.btn-20-off').click(function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('#CollectionSection').removeClass('show-new');
    $('#CollectionSection').addClass('show-20-off');
    $('#CollectionSection').removeClass('show-30-off');
    $('#CollectionSection').removeClass('show-40-off');
    $('#CollectionSection').removeClass('show-50-off');
  });
  $('.btn-30-off').click(function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('#CollectionSection').removeClass('show-new');
    $('#CollectionSection').addClass('show-30-off');
    $('#CollectionSection').removeClass('show-20-off');
    $('#CollectionSection').removeClass('show-40-off');
    $('#CollectionSection').removeClass('show-50-off');
  });
  $('.btn-40-off').click(function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('#CollectionSection').removeClass('show-new');
    $('#CollectionSection').addClass('show-40-off');
    $('#CollectionSection').removeClass('show-20-off');
    $('#CollectionSection').removeClass('show-30-off');
    $('#CollectionSection').removeClass('show-50-off');
  });
  $('.btn-50-off').click(function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('#CollectionSection').removeClass('show-new');
    $('#CollectionSection').addClass('show-50-off');
    $('#CollectionSection').removeClass('show-20-off');
    $('#CollectionSection').removeClass('show-30-off');
    $('#CollectionSection').removeClass('show-40-off');
  });



  // press tabs
  $('.press-tabs-nav li').on('click', function (event) {
      event.preventDefault();
      
      $(this).siblings().removeClass('tab-active');
      $(this).addClass('tab-active');

      $('.press-tabs-stage div').hide();
      $($(this).children().attr('href')).show();
  });

  $('.press-tabs-nav a:first').trigger('click'); // Default



  // update price in add to cart
  // $('.variant-clicker').click(function() {
  //   var curr_price = $('#ProductPrice').text();
  //   console.log(curr_price);
  //   $('.add-to-cart-price').append('<span class="add-to-cart-price">' + curr_price + '</span>');
  // });


  
  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 60 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
            	self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();
  


  // SCROLL TO FUNCTION
  $(function() {
    $('[data-toggle="elementscroll"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 120
          }, 1000);
          return false;
        }
      }
    });
  });


 


  // 1st carousel, main
  $('.carousel-main').flickity({
    arrowShape: { 
     x0: 10,
      x1: 30, y1: 50,
      x2: 35, y2: 50,
      x3: 15
    }
  });

  // 2nd carousel, navigation
  $('.carousel-nav').flickity({
    asNavFor: '.carousel-main',
    contain: true,
    pageDots: false,
    arrowShape: { 
      x0: 10,
      x1: 30, y1: 50,
      x2: 35, y2: 50,
      x3: 15
    }
  });

  // 3rd carousel, main
  // $('.variants-slider').flickity({
  //   groupCells: 2,
  //   pageDots: false,
  //   arrowShape: { 
  //    x0: 10,
  //     x1: 30, y1: 50,
  //     x2: 35, y2: 50,
  //     x3: 15
  //   }
  // });


//   var carousel = document.querySelector('.testimonial-slider');
//   var flkty = new Flickity( carousel, {
//     initialIndex: Math.floor( Math.random() * carousel.children.length ),
//     wrapAround: true,
//     groupCells: false,
//     pageDots: true,
//     prevNextButtons: false,
//     arrowShape: { 
//      x0: 10,
//       x1: 30, y1: 50,
//       x2: 35, y2: 50,
//       x3: 15
//     }
//   });

    var carousel = document.querySelector('.testimonial-slider');
    var flkty = new Flickity( carousel, {
    wrapAround: true,
    groupCells: false,
    pageDots: true,
    prevNextButtons: false,
    arrowShape: { 
     x0: 10,
      x1: 30, y1: 50,
      x2: 35, y2: 50,
      x3: 15
    }
  });

    

}); // clode doc ready



$(window).on('load', function() {

   // 1st carousel, main
  $('.home-slider').flickity({
    wrapAround: true,
    dragThreshold: 75,
    arrowShape: { 
      x0: 10,
      x1: 30, y1: 50,
      x2: 35, y2: 50,
      x3: 15
    }
  });

  $('.site-overlay').addClass('loaded');


});

